// src/hooks/useAllProducts.js
import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../services/axiosInstance';

export function useAllProducts({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['products-minimal'],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        '/api/products?fields=id,code,name,uses,is_expiring,pharmacist_only&all=1'
      );
      return data.map(p => ({
        ...p,
        nameLower: (p.name ?? '').toLowerCase(),
        codeLower: String(p.code ?? '').toLowerCase(),
      }));
    },
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,          // (v5) use cacheTime in v4
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
}